// The vendored design-system bundle (ds-bundle.js) is a compiled IIFE that references a
// GLOBAL `React` (319 React.createElement calls) and attaches its exports to
// `window.NEOCockpitDesignSystem_04cf2b`. It is not an ES module and does not import React.
//
// To make it use the SAME React instance as the app (so hooks/context cross the boundary),
// we expose the npm React/ReactDOM on `window` BEFORE the bundle evaluates. ESM guarantees a
// module's body runs before any subsequent sibling side-effect import, so importing this file
// before "./vendor/ds-bundle.js" (see ./index.ts) satisfies that ordering.
import * as React from "react";
import * as ReactDOM from "react-dom";

declare global {
  interface Window {
    React: typeof React;
    ReactDOM: typeof ReactDOM;
    NEOCockpitDesignSystem_04cf2b: Record<string, unknown>;
  }
}

window.React = React;
window.ReactDOM = ReactDOM;

export {};
